/* eslint-disable */ import { createPresetsFactory } from '@salsita-ai/platform-project-sdk/domain';
export const createPresets = createPresetsFactory();
export const generatedPresets = createPresets([
    {
        name: 'Start from scratch',
        description: 'Begin with a blank canvas and define your own layout from the ground up',
        img: '/images/custom-deck.png',
        rootEntityType: 'Deck',
        initialDomainEntities: [
            {
                id: 'Deck-1',
                type: 'Deck',
                postType: 'Timber',
                postStyle: 'SquareStainless',
                postStainlessFinish: 'Satin',
                handrailType: 'FlatTimber',
                fixingSystem: 'ForkWithSaddles',
                finish: 'Bright',
                numberOfWires: 11,
                useThinIntermediatePosts: false,
                thinIntermediatePostType: 'SatinStainless'
            }
        ]
    }
]);

//# sourceMappingURL=presets.js.map